$(function(){
  // console.log('start ajax color lists');
  console.log(databaseTable);
  $('.cart-container').on('click', function() { //When Cart / Option Area is Clicked.
    let getCurrentForm =
          document.getElementById(
              this.getAttribute('id') //Get id of current .cart-container
                  .replace('cartContainer', 'cartForm')
              ), //Gets current form id.
        formSelects = Array.from(getCurrentForm.querySelectorAll('select')), //Gets all select elements from current form and creates a new Array
        sizeSelectIds = formSelects.map(a=> a.id).filter(id => id.match(/size/i)), //Gets select elements with "size" or "Size" in id.
        colorSelectIds = formSelects.map(a => a.id).filter(id => id.match(/color/i)); //Gets select elements with "color" or "Color" in id.
  // console.log(formSelects);
  // console.log(sizeSelectIds);
  // console.log(colorSelectIds);

    //Simon: Note: This still works fine, may need tweaking.
    let cartSubmit = document.getElementById(this.getAttribute('id').replace('cartContainer', 'cartSubmit')),
        cartItems = ['cartID',  'itemName', 'itemPrice', 'itemQty', 'itemNumber', 'itemHandling', 'itemShipMethod', 'itemWeight', 'itemExempt', 'itemDiscount', 'itemSilentPost', 'itemDropShip', 'itemESD', 'itemRecurring', 'itemThumbnail', 'itemReserved'], //cartSubmit value{items}.
        altPrice = cartSubmit.getAttribute('data-price'), //backup price for when value price = 0 (Sectional Stripes)
        altWeight = cartSubmit.getAttribute('data-weight'), //backup weight for when value weight = 0 (Sectional Stripes)
        cartValue = cartSubmit.getAttribute('value').split('|'); //cartSubmit value{values}.
  // console.log(cartSubmit);
  console.log(altPrice);
  // console.log(cartValue);
    const cartValues =  cartValue.reduce(function(result, field, index) {
                        result[cartItems[index]] = field;
                        return result;
                        }, {}); //Function combines cartSubmit value {items : values}

  console.log(cartValues);
    let RequestURL = '/ajax/ajax-colors.php'; //Assign ajax file to variable.
    let price = cartValues.itemPrice === '0' ? altPrice : cartValues.itemPrice,
        weight = cartValues.itemWeight === '0' ? altWeight : cartValues.itemWeight,
        partNumber = cartValues.itemNumber;

    let querySelects = colorSelectIds.map(id => id.split('-')[0] + 's');
  console.log(price);
  console.log(partNumber);

    $(this).off('click'); // remove handler stop repeated ajax requests from same section

    $.getJSON(
      RequestURL, {
        selects: querySelects,
        price : price, //value sent to RequestURL via $_GET[]
        weight : weight, //value sent to RequestURL via $_GET[]
        table : databaseTable, //
        part_number: partNumber, //value sent to RequestURL via $_GET[]
        percentage : 10, //value sent to RequestURL via $_GET[]
        beforeSend : function(){console.log(cartValues.itemNumber)}
      },
      function (data) {
  console.log(data);
      colorSelectIds.forEach(function (item) {
        let itemId = '#' + item;
        let itemData = item.split('-')[0] + 's';
  // console.log('Select Element id: ' + itemId);
  // console.log('Ajax data. Item: ' + itemData);
  // console.log(data[itemData].length);
  // console.log(data[itemData][2]);
        $.each(data[itemData], function (i, color) {
          $(itemId).append($('<option>', {
            'data-icon': 'fas fa-square',
            'data-color': color.optionHEXColor,
            'data-gradient': color.optionGradient,
            'data-specs': color.optionSpecs,
            'data-priceload': color.optionPriceLoad,
            value: color.optionValue,
            text: color.optionText // '\ue905\xa0\xa0\xa0' +
          })); // $.each(itemData, function (i, color) { END
        }); // $.each(data.mainColors, function (i, color) { END

  // console.log('Number of color in ' + itemId + ' list: ' + data[itemData].length); // Number of items in color list.

        let buildCounter = data[itemData].length + colorSelectIds.length,
            placeholderText = '<img src="/images/icons/ColorSwatch.svg" height="17px" style="float: left; padding-top: 5px;"> ' +
            $(itemId).data('default-text');

        function cformatSelection (item) { //format item before / after selection
          let originalOption = item.element;
          if(!$(originalOption).data('color') && !$(originalOption).data('gradient')) {
            return $('<div>' + item.text +  '</div>'); // If nothing is yet selected (fresh)
          } else if($(originalOption).data('color')) {
            let markup =
                '<span class="select2-selection__selected"><i class="select2-selection__selected ' + $(originalOption).data('icon') +
                '" style="color:' + $(originalOption).data('color') + '\; text-shadow: 2px 2px 16px #272634\;"></i> ' + item.text + ' ' + $(originalOption).data('priceload') + ' </span>';
            return $(markup); // Once item is selected.
          } else {
            let markup =
                '<span><i class="select2-selection__selected ' + $(originalOption).data('icon') +
                '" style="' + $(originalOption).data('gradient') +
                ' -webkit-background-clip: text\; -webkit-text-fill-color: transparent\; display: initial\;"></i> ' + item.text + ' ' + $(originalOption).data('priceload') + ' </span>';
            return $(markup); // Once item is selected.
          } //if(!$(originalOption).data('color') && !$(originalOption).data('gradient')) { END


        } // function cformatSelection (item) { END

        function cformatResult(item) { //format result drop down list
          buildCounter--;
          if (buildCounter === 0){
            setTimeout(function(){
              // console.log('Select2 HTML Built!!')
              //logic // Use to hide the loader / notification after select2 has built list
            }, 800);
          } //if (buildCounter === 0){ END
          // console.log(buildCounter);
          // console.log(item);
          // console.log('item id is: ' + item.id);
          let originalOption = item.element;
          if ($(originalOption).data('color')) {
            let markup =
                '<div class="select2-result-container">' +
                '<i class="select2-result-tile ' + $(originalOption).data('icon') + '" style="color: ' + $(originalOption).data('color') + '\; text-shadow: 2px 2px 16px #272634\;"></i>' +
                '<div class="select2-result-info">' +
                '<div class="select2-result-title">' + item.text + '</div>' +
                '<div class="select2-result-specs">'+ $(originalOption).data('specs') +'</div>' +
                '<div class="select2-result-priceload">' + $(originalOption).data('priceload') + '</div>' +
                '</div>' + // info close
                '</div>'; //container close
            return $(markup); // Formatted drop down list
          } else {
            let markup =
                '<div class="select2-result-container">' +
                '<i class="select2-result-tile fas fa-square" style="' + $(originalOption).data('gradient') +
                ' -webkit-background-clip: text\; -webkit-text-fill-color: transparent\; display: initial\;"></i>' +
                '<div class="select2-result-info">' +
                '<div class="select2-result-title">' + item.text + '</div>' +
                '<div class="select2-result-specs">'+ $(originalOption).data('specs') +'</div>' +
                '<div class="select2-result-priceload">' + $(originalOption).data('priceload') + '</div>' +
                '</div>' + // info close
                '</div>'; //container close
            return $(markup); // Formatted drop down list
          } //if ($(originalOption).data('color')) { END


        } //function cformatResult(item) { END

        $(itemId).select2({
            width: "100%",
            placeholder: placeholderText,
            escapeMarkup: function (markup) { return markup; },
            templateSelection: cformatSelection,
            templateResult: cformatResult,
            allowHtml: true
        }); // $(itemId).select2({ END

        // $(itemId).on('select2:opening', function (e) {
        //   // console.log(itemId + ' select triggered'); // works for select box opened / being populated.
        // });


        // $(itemId).on('select2:closing', function (e) {
        //   // console.log(itemId + ' select closed');
        // });

        // $(itemId).on('select2:selecting', function (e) {
        //   // console.log(itemId + ' select selecting');
        // });

      }); // colorSelectIds.forEach(function (item) { END
// console.log('Ajax work complete for #' + getCurrentForm.id); //
// console.log(getCurrentForm);
// console.clear();

    }); // $.getJSON(RequestURL, function (data) { END

    sizeSelectIds.forEach(function (item) {
      console.log(item);
      let itemId = '#' + item;
      let placeholderText = '<img src="/images/fontawesome/svg/light/ruler-combined.svg" height="17px" style="float: left; padding-top: 5px;"> ' + $(itemId).data('default-text');


      function sizeSelectFormat(item) {
        let originalOption = item.element;
        if (!$(originalOption).data('price')) {
          return $('<span>' + item.text +  '</span>');
        } else {
          return $('<span class="select2-size-selection__selected"><i class="' + $(originalOption).data('icon') + '" style=""></i> ' + item.text + ' \$' + $(originalOption).data('price') + '</span>');
        }
      } // function sizeSelectFormat(item) { END

      function sizeResultFormat(item) {
        let originalOption = item.element;
        let markup =
            '<div class="select2-size-result-container">' +
            '<i class="select2-size-result-tile ' + $(originalOption).data('icon') + '" style="text-shadow: 2px 2px 16px #272634\;"></i>' +
            '<div class="select2-size-result-info">' +
            '<div class="select2-size-result-title">' + item.text + '</div>' +
            '<div class="select2-size-result-mm">Metric Dimensions: '+ $(originalOption).data('width_mm') +'mm Wide by ' + $(originalOption).data('height_mm') + 'mm High</div>' +
            '<div class="select2-size-result-price">\$' + $(originalOption).data('price') + '</div>' +
            '</div>' + // info close
            '</div>'; //container close
        return $(markup); // Formatted drop down list
      }

      $(itemId).select2({
        // width: "100%",
        placeholder: placeholderText,
        templateSelection: sizeSelectFormat,
        templateResult: sizeResultFormat,
        allowHtml: true
      }); // $(itemId).select2({ END
      $(itemId).on('select2:opening', function (e) {
        // console.log(itemId + ' select triggered'); // works for select box opened / being populated.
      });

      $(itemId).on('select2:open', function (e) {
        // console.log(itemId + ' select changed');
      });

    }); // vehicleSelectIds.forEach(function (item) { END
  }); // $('form').submit(function(e){ END
}); // $(function{ END

